import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import NavBar from "../components/Navigation/NavBar";
import CustomInput from "../components/CustomInput";
import { useLocation, useNavigate } from "react-router-dom";
import { BASE_URL, HOME_PATH, PROFILE_PATH } from "../utility/path";
import { getConfig, getConstant, handleErrorResponse, handleHeader, validateServiceCharge } from "../services/functions";
import { spinner } from "../redux/slices/spinnerSlice";
import axios from "axios";
import CustomSelect from "../components/CustomSelect";
import { setHeader } from "../redux/slices/headerSlice";
import MainContainer from "../components/MainContainer";
import { showAlert } from "../redux/slices/alertSlice";
import { StimingData, EtimingData } from "../utility/timingUtils";


const ChangeService = ({ }) => {

  const dispatch = useDispatch();
  const profile = useSelector(state => state.profile);
  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state;
  const categoriesData = useSelector(state => state?.categories?.data);


  const [isCategoryUser, setCategoryUser] = useState(categoriesData.some(c => c.name === 'user' && profile?.data?.category?.length > 0 && profile?.data?.category?.[0] === c.id));
  
  const [state, setState] = useState({
    category: data?.category?.[0] || "",
    fee: data?.fee || 1,
    id: data?.id,
    aboutme:data?.aboutme,
    instalink:data?.instalink,
    fblink:data?.fblink,
    startTime: data?.startTime || "",
    endTime: data?.endTime || "",
  });

  const handleChange = input => e => {
    if(input === 'fee'){
      const numericValue = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
      const truncatedValue = numericValue.slice(0, 5); // Limit to 6 characters
      setState({ ...state, [input]: truncatedValue });
    }else{

      if(e.target.value === 'Select service category' || e.target.value === 'Select start time' || e.target.value === 'Select end time'){
        return;
      }
            
      setState({ ...state, [input]: e.target.value });      
      setCategoryUser(categoriesData.some(c => c.name === 'user' && e?.target?.value === c.id))
    }
    
  }

  const handleClick = async (event) => {
    event.preventDefault();
    //dispatch(updateProfileAddressAction(state));
    dispatch(spinner(true));
    const config = getConfig();

    try {
      let formData = new FormData();
      formData.append("id", state.id);
      formData.append("fee", state.fee);
      formData.append("category", state.category);
      formData.append("aboutme", state?.aboutme || "");
      formData.append("instalink", state?.instalink || "");
      formData.append("fblink", state?.fblink || "");
      formData.append("startTime", state?.startTime || "");
      formData.append("endTime", state?.endTime || "");

      const { data } = await axios.post(`${BASE_URL}/api/users/updateProfileCategory`, formData, config);
      dispatch(setHeader({ gotoName: "Home", gotoAction: HOME_PATH }));
      dispatch(spinner(false));
      dispatch(showAlert({ message: 'Success', success: true }));
      navigate(PROFILE_PATH);
      return data;
    } catch (error) {
      console.log(error?.message);
      dispatch(spinner(false));
      const errorResponse = handleErrorResponse(error, dispatch);
      return errorResponse;
    }
  }

  const hasChanges =
  state?.category   !== data?.category?.[0]   ||
  state?.aboutme    !== data?.aboutme    ||
  state?.startTime    !== data?.startTime    ||
  state?.endTime    !== data?.endTime    ||
  state?.instalink  !== data?.instalink  ||
  state?.fblink     !== data?.fblink;

  const renderForm = () => {
    return (
      <>
        {
          data?.category?.length && 
            <CustomSelect title="Select your profession category" handleChange={(e) => handleChange(e)} name="category" defaultOptionValue="Select service category" data={data.categoriesData} state={state} isDisable={false} tooltipInfo={""}/>
        }

        {/* <CustomInput title="Approx. service fee*" id="feeId" type="number" placeholder="&emsp;&emsp;&emsp;&emsp;Service charge*" handleChange={handleChange} name="fee" value={state?.fee} preInputText="INR" maxLength={5}/> */}
        {!isCategoryUser && <CustomInput title="About me" id="aboutme" type="text" placeholder="About me" handleChange={handleChange} name="aboutme" value={state?.aboutme} maxLength={250}/>}

        {!isCategoryUser && <CustomSelect title="Select start time ⏰" handleChange={(e) => handleChange(e)} name="startTime" defaultOptionValue="Select start time" data={StimingData} state={state} isDisable={false} tooltipInfo={""}/>}

        {!isCategoryUser && <CustomSelect title="Select end time ⏰" handleChange={(e) => handleChange(e)} name="endTime" defaultOptionValue="Select end time" data={EtimingData} state={state} isDisable={false} tooltipInfo={""}/>}

        {/* <small className="info"><i><strong>Example: </strong>https://www.instagram.com/yourpage</i></small> */}
        {!isCategoryUser && <CustomInput title="Instagram" id="instalink" type="text" placeholder="Enter Instagram Link" handleChange={handleChange} name="instalink" value={state?.instalink} maxLength={200}/>}
        
        {/* <small className="info"><i><strong>Example: </strong>https://www.facebook.com/yourpage</i></small> */}
        {!isCategoryUser && <CustomInput title="Facebook" id="fblink" type="text" placeholder="Enter Facebook Link" handleChange={handleChange} name="fblink" value={state?.fblink} maxLength={200}/>}
        
        <button type="button" className="btn btn-primary" onClick={(e) => handleClick(e)} disabled={!hasChanges || profile?.loading || !state?.category}>{profile?.loading ? "Loading.." : "Save"}</button>
      </>
    );
  }

  useEffect(() => {
    handleHeader({...getConstant("CHANGE_SERVICE")},dispatch);


    return () => {}
  }, []);

  return (
    <>
      <NavBar />
      <MainContainer>
        {renderForm()}
      </MainContainer>
    </>
  );
}

export default ChangeService;
